<template>
	<div>
		<div v-if="formShow" style="background-color: white;">
			<formmain ref="formmain" :windowType="windowType" :width="width" :height="height" v-bind="$props" :mainForm="mainForm"
				:loading="loading" @show="show" @hide="hide" @windowmodalLoad="windowmodalLoad" @forward="forward">
				<template #title>
					<div>{{extra.title?extra.title:title}}</div>
				</template>
				<template #main>
					<toolbar v-if="formToolbarConfig" :formToolbarConfig="formToolbarConfig" :mainForm="mainForm"
						:id="id" @buttonclick="toolbarClick" />
					<div class="full"
						style="overflow-y: auto;overflow-x: hidden;box-sizing: border-box;padding: 40px 10px;"
						:ref="name+'_form'"></div>
				</template>
				<template #footer>
					<template v-if="controlltype==3 && device=='pc'">
						<!-- <vxe-button status="primary" content="启用编辑" @click="activeEdit"></vxe-button> -->
					</template>
					<template v-else>
						<template v-if="device!='pc'">
							<div class="flex">
								<van-button type="info" style="flex: 1;" text="保存待发"
									v-if="(sourceData && sourceData.isdraft==1 || flowprogressid==0) && isflow==1"
									@click="submit(1)">
								</van-button>
								<van-button type="default" style="flex: 1;" text="取消" @click="back('cancle')">
								</van-button>
								<van-button type="primary" style="flex: 1;" :text="isflow==1?'提交':'确定'"
									@click="submit(0)"></van-button>
							</div>
						</template>
						<template v-else>
							<div class="flex" style="flex-direction: column;width: 100%;">
<!-- 								<div class="flex" style="justify-content: flex-end;">
									<vxe-button v-if="isflow==1" status="warning" >流程模拟</vxe-button>									
								</div> -->
								<el-divider></el-divider>
								<div class="flex" style="justify-content: flex-end;">
									<vxe-button status="" content="保存待发"
										v-if="(sourceData && sourceData.isdraft==1 || flowprogressid==0) && isflow==1 && id==0"
										@click="submit(1)">
									</vxe-button>										
									<vxe-button status="" content="取消" @click="back('cancle')"></vxe-button>
									<vxe-button v-if="isflow==1 && id!=0" status="warning" @click="submit(1)">仅保存不提交</vxe-button>													
									<vxe-button status="primary" :content="isflow==1?'提交':'确定'" @click="submit(0)"></vxe-button>
								</div>
							</div>

						</template>

					</template>
				</template>
			</formmain>
		</div>

		<!-- 		<van-popup v-model="commentShow" v-if="device!='pc'" :style="{ height: '90%' ,width:'90%'}" :lazy-render="true">
			<div class="full flex" style="flex-direction: column;align-items: center;justify-content: center;">
				<div class="full" style="position: relative;flex: 1;">
					<comment :flowprogressid="flowprogressid" />
				</div>
				<van-button type="default" @click="commentShow=false" block>返回</van-button>
			</div>
		</van-popup> -->
		<!-- 		<vxe-modal v-model="commentShow" width="1000" height="600" :destroy-on-close="true" title="处理人意见区" show-footer>
			<template #default>
				<comment :flowprogressid="flowprogressid" />
			</template>
		</vxe-modal> -->


		<formwindow :formConfig="formModule" v-if="formModule.show" @back="formBack" />

		<slot name='plug'></slot>
	</div>

</template>
<style>
	.el-form-item {
		margin-bottom: 0px;
	}

	.form_loading {
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
</style>
<script>
	//import comment from '@_system/components/forms/window/comment.vue'
	import formmain from '@_system/components/base/formmain.vue'
	import toolbar from '@_system/components/base/toolbar.vue'
	import * as dd from 'dingtalk-jsapi';
	export default {
		props: {
			id: {
				type: [Number, String],
				default: () => {
					return 0
				}
			},
			name: {
				type: String,
				default: () => {
					return ''
				}
			},
			controlltype: {
				type: [Number, String],
				default: () => {
					return 1
				}
			},
			foreingKey: {
				type: Object,
				default: () => {
					return {}
				}
			},
			extra: {
				type: Object,
				default: () => {
					return {}
				}
			},
			windowName: {
				type: String,
				default: () => {
					return ''
				}
			},
			windowType: {
				type: String,
				default: () => {
					return 'modal'
				}
			},
			isflow: {
				type: [Number, String],
				default: () => {
					return 0
				}
			},
			flowprogressid: {
				type: [Number, String],
				default: () => {
					return 0
				}
			},
			flowid: {
				type: [Number, String],
				default: () => {
					return 0
				}
			},
			device: {
				type: [String],
				default: () => {
					return window.systemMethods.device()
				}
			},
		},
		data() {
			return {
				componentname: 'form',
				currentnodeid:null,
				moduleName: null,
				mainForm: this,
				formToolbarConfig: null,
				formShow: true,
				loadHandle: null,
				sourceData: null,
				showHeader: true,
				store: {},
				fApi: {},
				modalShow: false,
				loading: false,
				width: 0,
				height: 0,
				minWidth: 0,
				title: '',
				formModule: {
					component: '',
					name: '',
					id: 0,
					show: false,
					controlltype: 1,
					foreingKey: {},
					extra: {},
				},
				formwindowShow: false,
				currentcontrollid: 0,
				windowModal: null,
				dataload: {
					main: false
				},
				aftertabledataload: [],
				nodeEvent:[],
				commentShow: false,
				popoverComponenet: [],
				commitType: 'once',
				randerformdata:true,
				
			}

		},

		watch: {

		},
		computed: {

		},
		created() {
			if (this.extra.componentname) {
				this.componentname = this.extra.componentname
			}
		},
		mounted() {
		
			this.extra.customertype = this.componentname?this.componentname.replace('form',''):null
			//console.log(this.windowName, this.windowType)
			this.moduleName = this.name
			this.$nextTick(() => {
				this.init()
			})
		},

		methods: {

			init() {
				new Promise((resolve) => {
					if (this.id == 0) {
						this.loading = false
					}
					if (this.beforeInit) {
						this.beforeInit(resolve)
					} else {
						resolve()
					}
				}).then(() => {
					this.$api.form.create({
						id: this.moduleName,
						controlltype: this.controlltype,
						isflow: this.isflow,
						flowprogressid: this.flowprogressid,
						flowid: this.flowid,
						componentname: this.componentname,
						formtoken: Date.parse(new Date())
					}).then((e) => {
						let res = e.config
						this.currentcontrollid = res.currentcontrollid
						this.rule = res.rule
						if (this.device != 'pc') {
							this.rule.option.form.title = false
							this.rule.option.global['*'].col.span = 24
						}
						this.rule.rule.forEach((item, index) => {
							if (item.validate) {
								let validate = item.validate
								validate.forEach((val) => {
									val.pattern = val.pattern ? eval(val.pattern) :
										undefined
								})
							}

							if (item.value === 'currentstaff') {
								item.value = this.id == 0 ? this.$store.state.system.user.id : null
							}
							if (item.value === 'currentdepartment') {
								item.value = this.id == 0 ? this.$store.state.system.user
									.departmentid : null
							}
							if (item.type == '$popover') {
								this.popoverComponenet.push({
									mountcomponent: item.props.mountcomponent,
									field: item.field
								})
							}
							if (item.field && item.field.indexOf('$son') != -1) {
								if (item.props.buttons[0].code == 'hidden' && !item.props.buttons[
										0].disabled) {
									item.props.disabled = true
									this.rule.rule[index - 1].hidden = true
								}
								this.dataload[item.field] = false
							}
							if (this.popoverComponenet.findIndex((c) => {
									return c.mountcomponent === item.field
								}) !== -1) {
								item.props.disabled = true
								this.rule.rule[index - 1].hidden = true
							}


						})

						if (this.extra.defaultvalue) {
							for (let i in this.extra.defaultvalue) {
								for (let j in this.rule.rule) {
									if (this.rule.rule[j].field == i) {
										this.rule.rule[j].value = this.extra.defaultvalue[i]
									}
								}
							}
						}
						//console.log(this.windowName)
						//this.title = res.title
						this.title = this.windowName
						this.width = res.rule.width
						this.height = res.rule.height
						this.minWidth = this.width
						this.openwindow()
					}, () => {
						if (this.device != 'pc') {
							this.hide()
							this.back('cancel')
						} else {
							if (this.windowType != 'window') {
								this.hide()
							} else {
								this.formShow = false
							}
						}
						this.loading = false
						//console.log(res)
					})
				})
			},
			openwindow() {
				if (this.windowType === 'window' && this.device == 'pc') {

					// this.width = '100%'
					// this.height = '100%'
					this.showHeader = false
					this.show()
				} else {

					if (this.$refs.formmain) {
						this.$refs.formmain.modalShow()
					}

					//this.modalShow = true
				}
			},
			checkDivider(rule) {
				let newRule = []
				rule.forEach((item) => {
					if (!item.hidden) {
						newRule.push(item)
					}
				})
				newRule.forEach((item, index) => {
					if (index != 0 && item.type == 'el-divider' && newRule[index - 1].type == 'el-divider') {
						newRule[index - 1].hidden = true
					}
				})
			},
			windowmodalLoad(e) {
				this.windowModal = e.windowModal
				if(this.windowModal.flowprogress){
					this.currentnodeid = this.windowModal.flowprogress.current.currentnodeid
				}
			},
			show() {
				if (this.id != 0) {
					this.get().then(()=>{
						this.formCreate()
					})
				} else if(this.extra.copyid){
					this.get(null, this.extra.copyid).then(()=>{
						this.formCreate()
					})
				}else{
					this.loading = false
					this.formCreate()
					this.ready()
				}
	
			},			
			formCreate(){
				let rule = this.rule.rule
				let option = this.rule.option
				option.el = this.$refs[this.moduleName + '_form']
				if (this.beforeFormCreate) {
					this.beforeFormCreate(rule)
				}	
				this.fApi = this.$formCreate(rule, option)
				this.fApi.myformOption = {
					$store: this.$store,
					type: this.id != 0 ? 'update' : 'add'
				}
				this.autoRegest(rule)
				if (this.regestEvent) {
					this.regestEvent(rule, this.fApi)
				}	
				this.fApi.nextTick(() => {
					this.setFormData()		
				})
				this.$emit('show')
			},	
			setFormData(){
				if(this.sourceData){
					this.randerformdata = true
					this.beforeRender(this.sourceData)
					let fields = this.fApi.fields()
					let formdata = {}
					fields.forEach((item) => {
						formdata[item] = this.sourceData[item]
					})
					this.fApi.setValue(formdata)
					this.$nextTick(()=>{
						this.randerformdata = false
						this.afterGet(this.sourceData)
					})
					
				}
			},
			autoRegest(rule) {
				rule.forEach((item) => {
					if (item.field) {
						if (item.field.indexOf('$son') != -1) {
							let popoverComponenetIndex = this.popoverComponenet.findIndex((c) => {
								return c.mountcomponent === item.field
							})
							//console.log(popoverComponenetIndex,item,123)
							if (popoverComponenetIndex !== -1 && item.props.buttons[0].code == 'hidden' && item
								.props.buttons[0].disabled) {
								let mountcomponent = this.fApi.el(this.popoverComponenet[popoverComponenetIndex]
									.mountcomponent)
								
								this.fApi.el(this.popoverComponenet[popoverComponenetIndex].field).setComponent(
									mountcomponent)
								this.fApi.mergeRule(item.field, {
									props: {
										disabled: false
									}
								})
							}
							this.fApi.mergeRule(item.field, {
								props: {
									mainid: this.extra.copyid ? this.extra.copyid : this.id,
								}
							})
							let buttons = item.props.buttons
							let obj = {
								tablefieldChange: this.tablefieldChange,
								tablefieldButtonclick: this.tablefieldButtonclick,
								tableInsert: this.tableInsert,
								tableAdd: this.tableAdd,
								afterTableInsert: this.afterTableInsert,
								aftertabledelete: this.aftertabledelete,
								toolsSubmit: this.toolsSubmit,
								dataload: this.tableDataLoad,
								boxdataload: this.boxdataload,
								boxdatapenetrate: this.boxdatapenetrate
							}
							buttons.forEach((button) => {
								if (button.code != 'add' && button.code != 'del') {
									obj[button.code] = this[button.code + '_' + item.field.replace('$son_',
										'')] ? this[
										button.code + '_' + item.field.replace('$son_', '')] : () => {
											console.warn( '【form】'+button.code + '_' + item.field.replace('$son_', '') +'方法不存在')
										}
								}
							})
						//console.log(item.field)
							this.fApi.mergeRule(item.field, {
								on: obj
							})

							let son_table = this.fApi.el(item.field)
							son_table.store.form = this
						} else {
							let on = {}
							if (item.type == '$quote' && item.props.button) {
								on.submit = this.boxSubmit
							}	
							if (typeof this[item.field + 'Input'] === 'function') {
								on.input = this[item.field + 'Input']

							}
							if (typeof this[item.field + 'Change'] === 'function') {
								on.input = this[item.field + 'Change']
								// if (item.props.mount) {
								// 	this[item.field + 'Change']()
								// }
							}
							if (typeof this[item.field + 'Button'] === 'function') {
								on.inputButtonclick = this[item.field + 'Button']
							}
					
							this.fApi.updateRule(item.field, {
								on: on
							})
						}
					}


				})
				// deleteRule.forEach((item) => {
				// 	this.fApi.removeRule(item)
				// })

			},
			boxdatapenetrate(){
	
			},
			boxdataload() {

			},
			boxSubmit(e) {
				console.log(e,'boxSubmit')
				if (e.data) {
					let field = e.formCreateInject.field
					let fieldquote = this.fApi.getRule(field).props.quote
					e.oldvalue = this.fApi.getValue(field)
					e.newvalue = e.data[fieldquote]
					e.ischange = e.oldvalue != e.newvalue
					if (this.beforeBoxSubmit) {						
						this.beforeBoxSubmit(e)
					}
					this.setQuoteData(e)
					if (this.afterBoxSubmit) {						
						this.afterBoxSubmit(e)
					}
				}
			},

			setQuoteData(e) {						
				for (let i in e.data) {					
					this.rule.rule.forEach((j) => {	
						if (j.field && (j.type == '$quote' || j.type == '$emun' || j.type == '$staff' || j.type ==
								'$department') && j.props.moduleName == e
							.moduleName && j.props.quote ==
							i) {
								//console.log(j.field,e.data[i],111)
								let obj = {}
								obj[j.field] = e.data[i]
								//console.log(j.field,e.data[i])
								this.fApi.setValue(obj)
							}
					})
				}
			},
			hide(e) {
				this.loading = false
				this.$emit('back', {
					type: e
				})
				//this.back('cancle')
			},
			get(extra = null, id = this.id) {
				this.loading = true
				return new Promise((resolve) => {
					this.$api[this.moduleName].get(parseInt(id), {
						isflow: this.isflow,
						flowprogressid: this.flowprogressid,
						flowid: this.flowid,
						currentcontrollid: this.currentcontrollid,
						controlltype: this.controlltype,
						...extra
						//controlltype: 3
					}).then((res) => {
						if (res) {
							this.afterResponse(res).then(() => {
								for (let i in res) {
									if (i.match(/.*time$/g)) {
										res[i] = res[i] * 1000
									}
									if (i.match(/.*file$/g)) {
										res[i] = res[i] ? res[i] : []
									}
								}
								this.sourceData = res
								this.loading = false
								this.setdataloadstatus('main')
								//this.dataload.main = true
								this.ready()
							}, () => {})
						} else {
							this.back('cancle')
							this.$message.error('数据不存在')
						}
						
						//console.log(res)
						resolve()
					}, () => {
						this.loading = true
						resolve()
						this.hide()
					})
				})
			},
			copy(code) {
				return new Promise((reslove) => {
					this.loading = true
					this.$api[this.moduleName].copyBycode({
						code: code
					}).then((res) => {
						if (res) {
							for (let i in res) {
								if (i.match(/.*time$/g)) {
									res[i] = res[i] * 1000
								}
								if (i.match(/.*file$/g)) {
									res[i] = res[i] ? res[i] : []
								}
							}
							let fields = this.fApi.fields()
							fields.forEach((item) => {
								this.fApi.setValue(item, res[item])
								let rule = this.fApi.getRule(item)
								if (rule.on && rule.on.change && (typeof rule.on.change) ===
									'function') {
									rule.on.change(res[item])
								}
							})
							this.loading = false
							reslove(res)
						} else {
							this.$message.error('数据不存在')
							reslove(res)
						}
					}, () => {
						this.$message.error('数据不存在')
						reslove(null)
					})
				})
			},
			simulate(formData) {
				return new Promise((reslove)=>{
					let system = {
						isflow: this.isflow,
						flowprogressid: this.flowprogressid,
						flowid: this.flowid,
						currentcontrollid: this.currentcontrollid,
						simulate:1
					}
					this.$api[this.moduleName].save({
						system: system,
						...formData,
						...this.foreingKey
					}).then((res) => {
						reslove(res)
						this.loading = false
					}, () => {
						reslove()
						this.loading = false
					})
				})
			},
			save(formData, draft = 0, forward = 0) {
				
				let system = {
					isflow: this.isflow,
					flowprogressid: this.flowprogressid,
					flowid: this.flowid,
					currentcontrollid: this.currentcontrollid,
					draft: draft,
					forward: forward
				}
				if (this.windowModal) {
					system.comment = this.windowModal.comment
					system.flowmark = this.windowModal.flowmark
				}
				this.$api[this.moduleName].save({
					system: system,
					...formData,
					...this.foreingKey
				}).then((res) => {
					if(this.afterSave && typeof this.afterSave == 'function'){
						this.afterSave(res)
					}
					if (this.windowType === 'window') {
						this.back('save')
						// this.$alert('操作成功', '提示', {
						// 	confirmButtonText: '关闭',
						// 	type: 'success ',
						// 	callback: () => {
						// 		this.back('save')
						// 	}
						// })
					} else {
						this.$message({
							message: '操作成功',
							type: 'success'
						})
						this.back('save')
					}
				}, () => {
					// if(this.savefail){
					// 	this.savefail(e)
					// }
					this.loading = false
					// if (this.loadHandle) {
					// 	this.loadHandle.close()
					// }
				})
			},
			update(formData, draft = 0, forward = 0) {
				let system = {
					isflow: this.isflow,
					flowprogressid: this.flowprogressid,
					flowid: this.flowid,
					currentcontrollid: this.currentcontrollid,
					draft: draft,
					forward: forward
				}
				if (this.windowModal) {
					system.comment = this.windowModal.comment
					system.flowmark = this.windowModal.flowmark
				}
				
				this.$api[this.moduleName].update(this.id, {
					system: system,
					...formData,
					...this.foreingKey
				}).then(() => {
					if (this.windowType === 'window') {
						this.back('update')
						// this.$alert('操作成功', '提示', {
						// 	confirmButtonText: '关闭',
						// 	type: 'success ',
						// 	callback: () => {
						// 		this.back('update')
						// 	}
						// })
					} else {
						this.$message({
							message: '操作成功',
							type: 'success'
						})
						this.back('update')
					}



				}, () => {
					this.loading = false
					// if (this.loadHandle) {
					// 	this.loadHandle.close()
					// }
				})
			},
			forward(e) {
				this.submit(0, {
					auth: e.data
				})

			},
			back(type) {

				if (this.windowType === 'window') {
					this.closeFormWindow()
				} else {
					if (this.commitType == 'once') {
						this.destroyForm(type)
					} else {
						this.restForm()
						this.$emit('reloadList')
						// this.$confirm('是否继续?', '提示', {
						// 	confirmButtonText: '确定',
						// 	cancelButtonText: '取消',
						// 	type: 'warning'
						// }).then(() => {
						// 	this.restForm()
						// }).catch(() => {
						// 	this.destroyForm(type)
						// })
					}
				}
			},
			closeFormWindow(){
				if (this.device != 'pc') {
					if (dd.env.platform !== 'notInDingTalk'){						
						dd.closePage({
							success: () => {},
							fail: () => {},
							complete: () => {},
						});
					}else{
						//this.loading = false
						this.$router.go(-1)
						this.$router.beforeEach((to, from, next) => {
							if (to.matched.length > 0) {
								next()
							} else {
								window.location.href = window.config.url
							}
						})
					}
				} else {	
					if (dd.env.platform !== 'notInDingTalk'){
						dd.quitPage({
							success: () => {},
							fail: () => {},
							complete: () => {},
						});
					}else{
						window.close()
					}		
				}
			},
			destroyForm(type) {
				if (this.fApi && typeof(this.fApi.destroy) === 'function') {
					this.fApi.destroy()
				}
				this.$refs.formmain.modalHide(type)
			},
			submit(draft = 0, forward = 0 , simulate = 0) {
				return new Promise((success)=>{
					if (this.createSubmit) {
						this.createSubmit()
					}
					if (this.controlltype != 3) {
						this.fApi.validate((valid, fail) => {
							if (valid) {
								this.fApi.submit((formData) => {
									new Promise((resolve) => {
										this.autoBeforeSubmit(formData).then(() => {							
											if (this.beforeSubmit) {
												this.beforeSubmit(formData, resolve)
											} else {
												resolve()
											}
										})
									}).then(() => {
										this.submitDataFormater(formData)
										this.loading = true
										if(simulate){
											this.simulate(formData).then((res)=>{
												success(res)
											})
										}else{
											if (this.id == 0) {
												this.save(formData, draft, forward)
											} else {
												this.update(formData, draft, forward)
											}
										}
									})
								})
							} else {
								this.loading = false
								for (let i in fail) {
									this.$message.error(fail[i][0].message)
									break
								}
							}
						})
					} else {
						this.back('cancle')
					}
				})
			},
			autoBeforeSubmit(formData) {
				return new Promise((resolve, reject) => {
					for (let i in formData) {
						formData[i] = formData[i] === undefined ? '' : formData[i]
					}
					let blankbuff = true
					let son = []
					let promise = []
					let rule = this.rule.rule
					for (let i = 0; i < rule.length; i++) {
						if (rule[i].field && rule[i].field.indexOf('$son') != -1) {
							let $son = this.fApi.el(rule[i].field)
							let sondata = $son.getTableData().fullData
							//console.log(rule[i],123123123)
							if (rule[i].config && rule[i].config.blank && sondata.length == 0) {
								this.$message.error(rule[i].tablename + '不能为空')
								reject()
								blankbuff = false
								break

							}
						}
					}
					if (!blankbuff) {
						return
					}
					rule.forEach((item) => {
						if (item.field && item.field.indexOf('$son') != -1) {
							son.push(item.field)
						}
					})
					son.forEach((item) => {
						let $son = this.fApi.el(item)
						promise.push($son.submit())
					})
					Promise.all(promise).then((res) => {
						son.forEach((sitem, index) => {
							formData[sitem] = res[index]
						})

						resolve()
					}, () => {
						this.loading = false
						reject()
					})
				})
			},


			submitDataFormater(formData) {
				for (let i in formData) {
					if (i.match(/^\$son/)) {
						for (let j in formData[i]) {
							formData[i][j].forEach((item) => {
								for (let k in item) {
									if (k.match(/.*time$/g)) {
										item[k] = this.convertToTimestamp(item[k])

										// if (item[k] >= 1000000000000) {
										// 	item[k] = item[k] ? item[k] / 1000 : item[k]
										// } else {
										// 	item[k] = item[k] ? item[k] : item[k]
										// }
									}
								}
							})
						}
					} else if (i.match(/.*time$/g)) {
						console.log(i)
						formData[i] = this.convertToTimestamp(formData[i])
						// formData[i] = formData[i] ? formData[i] / 1000 : formData[i]
					}
				}
			},
			convertToTimestamp(value) {
				if (Object.prototype.toString.call(value) === '[object Date]') {
					return Math.floor(value.getTime() / 1000);
				} else if (typeof value === 'number' && !isNaN(value)) {
					if (value.toString().length === 10) {
						return value;
					} else if (value.toString().length === 13) {
						return Math.floor(value / 1000);
					}
				} else if (typeof value === 'string') {
					var date = new Date(value);
					if (!isNaN(date.getTime())) {
						return Math.floor(date.getTime() / 1000);
					}
				}
				return null;
			},
			cancle() {
				this.back('cancle')
			},
			activeEdit() {
				this.$emit('activeEdit')
			},
			setdataloadstatus(field,status=true){
				this.dataload[field] = status
				if(this.dataloadfinish()){
					
					if(this.nodeEvent[this.currentnodeid]){
						this.nodeEvent[this.currentnodeid].call()
					}
				}
			},
			dataloadfinish() {
				let buff = true
				for (let i in this.dataload) {
					if (!this.dataload[i]) {
						buff = false
					}
				}
				return buff
			},
			formBack() {
				this.formwindowShow = false
				this.formModule = {
					component: '',
					name: '',
					id: 0,
					show: false,
					controlltype: 1,
					extra: {},
					foreingKey: {},
				}
			},
			afterResponse(res) {
				return new Promise((reslove) => {
					reslove(res)
				})
			},
			beforeRender() {

			},
			afterGet() {

			},
			tablefieldChange() {

			},
			tableDataLoad(e) {				
				let field = '$son_' + e.module
				if (this.aftertabledataload[field]) {
					this.aftertabledataload[field].call(this, e)
				}
				this.setdataloadstatus(field)
				//this.dataload['$son_' + e.module] = true
			},
			tablefieldButtonclick(e) {
				let relationid = e.store.container.relationid
				if (e.store.box) {
					let box = e.store.box.add
					let page = {
						pageSize: 20,
						currentPage: 1
					}
					let form = {}
					form[e.itemProps.quote] = e.data.row[e.data.column.field]
					relationid.forEach((item) => {
						form[item.boxdataid] = e.data.row[item.tabledataid]
					})
					box.list(page, form).then((res) => {
						if (res.list.length != 0) {
							box.submitwidthreflash(res.list)
						} else {
							this.$message.error('刷新失败，未查询到数据')
						}
						e.e.resolve()
					})
				} else {
					e.e.resolve()
				}
			},

			ready() {

			},
			tableAdd(e) {
				e.next()
			},
			tableInsert() {

			},
			afterTableInsert() {

			},
			aftertabledelete() {

			},
			toolsSubmit() {

			},
			toolbarClick() {

			},
			getTableData(tablename,type="tableData") {
				let table = this.fApi.el('$son_' + tablename)
				if (table) {
					return table.getTableData()[type]
				} else {
					this.$message.error('子表不存在：' + tablename)
				}
			},
			restForm() {
				this.fApi.resetFields()
				this.rule.rule.forEach((item) => {
					if (item.field && item.field.indexOf('$son') != -1) {
						this.fApi.el(item.field).getGrid().reloadData([])
					}
				})
			}
		},
		components: {
			formmain,
			toolbar,
			//comment
		}
	}
</script>